module.exports = __webpack_public_path__ + "static/media/ico_simulation_skin_spots.a1d3448a.png";